
import { ReactNode } from "react";
import { ApiDataContextProvider } from "./api/ApiDataContext";
import { BrokerHubDataContextProvider } from "./broker-hub/BrokerHubDataContext";
import { DailyPricingDataContextProvider } from "./physical-markets/DailyPricingsDataContext";
import { ManagementDataContextProvider } from "./management/ManagementDataContext";
import { RiskManagementDataContextProvider } from './risk-management/RiskManagementDataContext';

type DataContextProviderProps = {
    children: ReactNode;
};

export function DataContextProvider({ children } :DataContextProviderProps) {
    return (
        <>
            <ApiDataContextProvider>
                <BrokerHubDataContextProvider>
                    <DailyPricingDataContextProvider>
                        <ManagementDataContextProvider>
                            <RiskManagementDataContextProvider>
                                {children}
                            </RiskManagementDataContextProvider>
                        </ManagementDataContextProvider>
                    </DailyPricingDataContextProvider>
                </BrokerHubDataContextProvider>
            </ApiDataContextProvider>
        </>
      );
}